import { GET_LOGINV2 } from '../action/auth';

const initialState = {
  data: [],
};

const auth = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_LOGINV2: {
      if (payload !== 'error') {
        localStorage.setItem('tokenV2', payload.token);
      }
      return {
        ...state,
        data: payload,
      };
    }

    default:
      return state;
  }
};

export default auth;
